const defaults = {
	country: 1,
	factory: 1,
}

export default defaults
